import { useToast } from '@/hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import * as Portal from '@radix-ui/react-portal';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, actions, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className='grid gap-1 flex-1 min-w-0'>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {actions && actions.length > 0 ? (
              <div className='flex gap-2 shrink-0'>
                {actions.map((actionElement, index) => (
                  <div key={index}>{actionElement}</div>
                ))}
              </div>
            ) : (
              action
            )}
            <ToastClose />
          </Toast>
        );
      })}
      {/* <Portal.Root> */}
      <ToastViewport />
      {/* </Portal.Root> */}
    </ToastProvider>
  );
}
